<template>
  <section class="container">
    <CoolLightBox 
      :items="items" 
      :index="index"
      loop
      @close="index = null">
    </CoolLightBox>
    <full-page ref="fullpage" :options="options">
      <div class="section" data-anchor="api1" id="section1api">
        <div class="fp-bg"></div>

        <div class="headerProyecto-api" id="headerProy">
          <v-container fluid>
            <v-row>
              <v-col cols="2"></v-col>
              <v-col cols="6">
                <v-row>
                  <div
                    class="titulo-proyecto-api"
                    style="position: absolute; font-family: 'Didot-bold'; color: black !important; opacity: 1; font-size: calc(14.5px + 2.18125vw); z-index: 9999;"
                  >
                    <p>Apiádate de mí</p>
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(10.5px + 1.08125vw);"
                  >
                    Bar quitapena
                  </div>
                </v-row>
                <v-row>
                  <div
                    style="position: relative; top:25vh; left: 10vw; font-family: 'Source'; color: black; font-size: calc(8.5px + 1.08125vw);"
                  >
                    Santiago 2019
                  </div>
                </v-row>
                <v-row>
                  <v-btn class="boton-volver-api" to="/proyectos">Volver</v-btn>
                  <!--           <div>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="cabeceraIsVisible" color="#372b5d">mdi-chevron-up</v-icon>
                  <v-icon large style="position:absolute; bottom:1vh; left: 50vw; transition: all 0.45s ease-in-out;" @click="toggleCabProy()" v-if="!cabeceraIsVisible" color="#372b5d">mdi-chevron-down</v-icon>
                  </div>-->
                </v-row>
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-container>
        </div>
        <div class="slide" id="slide1-1">
          <div class="fp-bg"></div>
        </div>

      </div>

      <div class="section" data-anchor="api2" id="section2api">
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <div class="fondo-gris-api">
                <v-row class="row1api">
                  <v-col cols="2">
                    <p class="programa-api">Programa</p>
                  </v-col>
                  <v-col cols="10" class="textocol1">
                    <p class="texto1api">
                      Barra de Cerveza Craft con 14 lineas, Salon de mesas
                      compartidas, terraza lounge y baños.
                    </p>
                  </v-col>
                </v-row>
                <v-row class="row2api">
                  <v-col cols="2">
                    <p class="programa-api">Colaboradores</p>
                    <br />
                  </v-col>
                  <v-col cols="10" class="textocol1">
                    <p class="texto1api">
                      Murales e ilustraciones por
                      <br />
                      <a
                        href="https://www.instagram.com/matiulloa_/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                        >@matiulloa_</a
                      >
                      <br />Soldador especialista por
                      <br />
                      <a
                        href="https://www.instagram.com/iracundataller/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                        >@iracundataller</a
                      >
                      <br />Gráfica y fotos por
                      <br />
                      <a
                        href="https://www.instagram.com/thejoystudio/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                        >@thejoystudio</a
                      >
                      <br />
                      <a
                        href="https://www.instagram.com/camilobdelpin/"
                        target="_blank"
                        style="font-family: 'Source-bold'; font-color: #372b5d !important;"
                        >@camilobdelpin</a
                      >
                    </p>
                  </v-col>
                </v-row>
                <v-row class="row3api">
                  <v-col cols="2">
                    <p class="programa-api">Superficie</p>
                  </v-col>
                  <v-col cols="10" class="textocol1">
                    <p class="texto1api">60 m2</p>
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col cols="6">
              <v-img :src="image_srcapi2" class="img-api2" cover @click="setIndex(1)"><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-img :src="image_srcapi3" class="img-api3" contain @click="setIndex(2)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="8"></v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-container>
      </div>

      <div class="section" data-anchor="api3" id="section3api">
        <v-container fluid>
          <v-row>
            <v-col cols="5">
              <v-img :src="image_srcapi4" class="img-api4" cover @click="setIndex(3)"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="black"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-col>
            <v-col cols="7">
              <div class="fondo-gris-api2">
                <v-row>
                  <p class="texto2api">
                    Creamos este espacio con una arquitectura que reúne la
                    nostalgia del bar de barrio chileno, el bolero y la
                    psicodelia del joven chileno actual, todo en función de una
                    gran barra de cerveza artesanal montón de líneas de cerveza
                    craft con el fin de que la barra sea el centro articulador
                    del espacio configurando un bar quitapena que acoge a todos
                    quienes han sufrido un dolor en el corazón.
                  </p>
                </v-row>
                <v-row>
                  <p class="texto2api">
                    Se plantea una fachada abierta hacia la calle integrando el
                    espacio público, por lo que se restaura antiguos marcos de
                    ventanas. A si mismo en el interior se mantienen las
                    materialidades originales integrando un proyecto de
                    iluminación y murales en las paredes.
                  </p>
                </v-row>
                <v-row>
                  <p class="texto2api">
                    Se trabaja junto a ilustradores, diseñadores gráfico y
                    fotógrafos para construir la imagen: logo, carta, instagram.
                    Teniendo como resultado un proyecto integral y completo bajo
                    un mismo concepto.
                  </p>
                </v-row>
              </div>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-container>
      </div>
    </full-page>
  </section>
</template>

<script>
import store from "../store";
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

export default {
  data() {
    return {
      proyectos: [
        {
          numero: 1,
          numeroString: "01",
          isActive: true,
          route: "/apiadate",
          titulo: "Apiádate de mí",
          resumen: "Bar quitapena",
          lugar: "Santiago",
          año: "2019",
          programa:
            "Barra de Cerveza Craft con 14 lineas, Salon de mesas compartidas, terraza lounge y baños",
          colaboradores: [
            "@matiulloa_",
            "@iracundataller",
            "@thejoystudio",
            "@camilobdelpin"
          ],
          superficie: "60 m2",
          descripcion: [
            "Creamos este espacio con una arquitectura que reúne la nostalgia del bar de barrio chileno, el bolero y la psicodelia del joven chileno actual, todo en función de una gran barra de cerveza artesanal montón de líneas de cerveza craft con el fin de que la barra sea el centro articulador del espacio configurando un bar quitapena que acoge a todos quienes han sufrido un dolor en el corazón.",
            "Se plantea una fachada abierta hacia la calle integrando el espacio público, por lo que se restaura antiguos marcos de ventanas. A si mismo en el interior se mantienen las materialidades originales integrando un proyecto de iluminación y murales en las paredes.",
            "Se trabaja junto a ilustradores, diseñadores gráfico y fotógrafos para construir la imagen: logo, carta, instagram. Teniendo como resultado un proyecto integral y completo bajo un mismo concepto."
          ]
        }
      ],
      media: [
        {
          thumb: require("../assets/apiadate2.jpg"),
          src: require("../assets/apiadate2.jpg"),
          caption: "<h4>1</h4>"
        }
      ],
      posicionLista: -25,
      items: [
        {
          src: require("../assets/apiadate1.jpg"),
        },
        {
          src: require("../assets/apiadate2.jpg"),
        },
        {
          src: require("../assets/apiadate3.jpg"),
        },
        {
          src: require("../assets/apiadate4.jpg"),
        },
        {
          src: require("../assets/1.jpg"),
        },
      ],
      index: null,
      proyectoSeleccionado: 1,
      cabeceraIsVisible: true,
      image_srcapi1: require("../assets/apiadate1.jpg"),
      image_srcapi2: require("../assets/apiadate2.jpg"),
      image_srcapi3: require("../assets/apiadate3.jpg"),
      image_srcapi4: require("../assets/apiadate4.jpg"),
      image_srcapiX: require("../assets/1.jpg"),
      options: {
        licenseKey: "265864DA-1DE54052-9BEBB977-EF50CFB8",
        parallax: true,
        parallaxKey: [
          "Y29sZWN0aXZvYWxxdWltaWEuY2xfYmxNY0dGeVlXeHNZWGc9OTJR",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfdjhXY0dGeVlXeHNZWGc9QVEw",
          "Y29sZWN0aXZvLWFscXVpbWlhLndlYi5hcHBfNjI0Y0dGeVlXeHNZWGc9WVlP"
        ],
        // parallaxKey: '7CD7B03B-68104BF5-88FFE8B4-2585F4CC',
        // activation-key for domain colectivoalquimia.cl: Y29sZWN0aXZvYWxxdWltaWEuY2xfcmg0Y0dGeVlXeHNZWGc9bHhi
        autoScrolling: true,
        anchors: ["api1", "api1b", "api2", "api3", "api4"],
        scrollbar: false,
        slidesNavigation: false,
        controlArrows: false,
        verticalCentered: false,
        bigSectionsDestination: "top",
        scrollingSpeed: "700",
        parallaxOptions: {
          type: "cover",
          percentage: 99,
          property: "translate"
        },
        onLeave: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            store.commit("esconder");
            document.getElementById("headerProy").style.top = "-60vh";
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        },
        afterLoad: function(origin, destination, direction) {
          console.log(destination);
          console.log(direction);
          if (origin.index == 0) {
            setTimeout(function() {
              document.getElementById("headerProy").style.top = "0vh";
            }, 2000);
          } else if (origin.index == 1 && direction == "up") {
            //document.getElementById("headerProy").style.top = "0vw";
            // store.commit("mostrar");
          }
        }
      }
    };
  },
  components: {
    CoolLightBox
  },
  metaInfo: {
    title: "Proyectos",
    titleTemplate: "%s | Apiádate de mí"
  },
  computed: {
    yLista() {
      return `transform: translateY(${this.posicionLista}%)`;
    }
  },
  mounted() {
    setTimeout(function() {
      document.getElementById("headerProy").style.top = "-60vh";
    }, 2000);
    window.addEventListener("wheel", this.onWheel, true);
  },
  destroyed() {
    window.addEventListener("wheel", this.onWheel, true);
  },
  methods: {
    isOnTop() {
      if (this.$refs.fullpage.api.getActiveSection().anchor == "api1") {
        return true;
      } else {
        return false;
      }
    },
    setIndex(index) {
      this.index = index;
    },
    onWheel(e) {
      e;
      if (this.$refs.routerViewRef.getSection() == "api1" && e.deltaY > 0) {
        document.getElementById("headerProy").style.top = "-60vh";
        this.cabeceraIsVisible = true;
      } else if (
        this.$refs.routerViewRef.getSection() == "api1" &&
        e.deltaY < 0
      ) {
        document.getElementById("headerProy").style.top = "0vw";
        this.cabeceraIsVisible = false;
      }
    },
    getSection() {
      return this.$refs.fullpage.api.getActiveSection().anchor;
    },
    getSectionIndex() {
      return this.$refs.fullpage.api.getActiveSection().index;
    },
    selectTitle() {
      this.$refs.fullpage.api.moveTo(2);
    },
    toggleCabProy() {
      console.log("toggleCabProy()");
      if (this.cabeceraIsVisible) {
        document.getElementById("headerProy").style.top = "-60vh";
        this.cabeceraIsVisible = false;
      } else {
        document.getElementById("headerProy").style.top = "0vw";
        this.cabeceraIsVisible = true;
      }

      //document.getElementById("bloque-aux").style.right = "-25vw";
    },
    move() {
      this.$refs.fullpage.api.moveTo(2, 1);
    },
    moveBack() {
      this.$refs.fullpage.api.moveTo(2, 0);
    }
  }
};
</script>

<style>
.fp-bg {
  background-size: cover;
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden; /* Chrome, Safari, Opera */
  backface-visibility: hidden;
}
.container {
  padding: 0px;
  margin: 0px;
  transition: all 0.45s ease-in-out;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}
.section {
  height: 100vh;
  z-index: -1;
}
#section1api {
  background-size: cover;
}
#section2api {
  background-size: cover;
}
#section3api {
  background-size: cover;
}
#section4api {
  background-size: cover;
}
#sectionXapi {
  height: 100vh;
}
#slide1-1 .fp-bg {
  background-image: url("../assets/1.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-2 .fp-bg {
  background-image: url("../assets/2.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-3 .fp-bg {
  background-image: url("../assets/3.jpg");
  background-size: cover;
  background-position: center 80%;
}
#slide1-4 .fp-bg {
  background-image: url("../assets/4.jpg");
  background-size: cover;
  background-position: center 80%;
}

.bajar {
  position: absolute;
  bottom: 5vh;
  left: 45vw;
}
.headerProyecto-api {
  position: absolute;
  top: 0;
  background-color: #fff;
  height: 60vh;
  width: 100%;
  transition: 925ms;
  z-index: 999;
}
.img-X {
  position: absolute;
  top: 0vh;
  left: 0;
  height: 100vh;
  width: 100%;
}
@media (min-width: 960px) {
  .texto1api {
    font-size: calc(4.5px + 0.91875vw);
    color: black;
    max-width: 30vw;
    font-family: "Source";
  }
  .texto2api {
    top: 5vh;
    font-size: calc(4.5px + 0.91875vw);
    color: black;
    padding-right: 1vw;
  }
  .img-api2 {
    position: absolute;
    max-height: 100vh;
    cursor: pointer;
  }
  .img-api3 {
    position: absolute;
    top: 49vh;
    left: 15vw;
    height: 50vh;
    margin-bottom: 1vh;
    cursor: pointer;
  }
  .img-api4 {
    position: absolute;
    top: 1vh;
    left: 10vw;
    max-width: 37vw;
    padding: 5vw;
    height: 97vh;
    cursor: pointer;
    z-index: 1;
  }
  .img-apiX {
    position: fixed;
    top: 0;
    left: 0;
    cursor: pointer;
    height: 200vh;
    width: 100vw;
    z-index: 99;
  }
  .alq-card1 {
    position: absolute;
    top: 5vh;
    left: 15vw;
  }
  .row1api {
    position: relative;
    height: 12vh;
  }
  .row2api {
    position: relative;
    height: 25vh;
  }
  .row3api {
    position: relative;
    height: 10vh;
  }
  .titulo-proyecto-api {
    position: absolute;
    font-family: "Didot-bold";
    color: black;
    font-size: calc(14.5px + 2.18125vw);
    top: 15vh;
    left: 25vw;
  }
  .titulo-proyecto-api::before {
    content: "";
    position: absolute;
    top: 35px;
    right: 100%;
    cursor: default;
    width: 1.5em;
    height: 3px;
    background: #000;
    z-index: 3;
  }
  .programa-ap {
    position: relative;
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 0.68125vw);
    margin-left: 5px;
  }
  .textocol1 {
    padding-left: 5vw;

    line-height: 1.3;
  }
  .fondo-gris-api {
    position: absolute;
    background-color: #e3dfe0 !important;
    left: 8vw;
    top: 0;
    margin-top: 1vh;
    max-width: 30vw;
    min-height: 40vh;
    padding-left: 1vw;
    padding-right: 0vw;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .fondo-gris-api2 {
    left: 10vw;
    position: relative;
    background-color: #e3dfe0 !important;
    padding-left: 3vw;
    padding-right: 1vw;
    margin-right: 5vw;
    max-width: 37vw;
    max-height: 80vh;
    padding-top: 50px;
    padding-bottom: 1vh;
  }
  .proyectos {
    position: fixed;
    top: 55vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    height: 6vw;
  }
  .nProyecto {
    position: relative;
    bottom: 6vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 5vh;
    left: 15vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #ffffff;
    line-height: 1;
  }
  .boton-siguiente {
    position: absolute;
    font-family: "Source";
    top: 30vw;
    left: 20vw;
    z-index: 9999;
  }
  .boton-anterior {
    position: absolute;
    font-family: "Source";
    top: 30vw;
    left: 10vw;
    z-index: 9999;
  }
  .boton-volver-api {
    position: absolute;
    font-family: "Source";
    bottom: 3vh;
    left: 25vw;
    z-index: 9999;
  }
}

@media (max-width: 960px) {
  .texto1api {
    font-size: calc(4.5px + 1.01875vw);
    color: black;
    margin-top: 1vh;
    padding-right: 2vw;
  }
  .texto2api {
    font-size: calc(5.5px + 1.01875vw);
    font-family: "Source";
    color: black;
    padding: 0;
  }
  .img-api2 {
    top: 12vh;
    right: 1vw;
    position: absolute;
    z-index: 1;
    height: 60vh;
    width: 48vw;
  }
  .img-api3 {
    position: absolute;
    left: 3vw;
    top: 60vh;
    height: 40vh;
    width: 45%;
    z-index: 99;
  }
  .img-api4 {
    position: absolute;
    top: 15vh;
    left: 2vw;
    padding: 5vw;
    width: 40vw;
    height: 50vh;
    z-index: 1;
  }
  .boton-volver {
    position: absolute;
    font-family: "Source";
    bottom: 20vw;
    left: 5vw;
    z-index: 9999;
  }
  .row1api {
    position: relative;
    height: 15vh;
  }
  .row2api {
    position: relative;
    height: 20vh;
  }
  .row3api {
    position: relative;
    top: 1vh;
    height: 10vh;
  }
  #section4api {
    background-image: url("../assets/1.jpg");
    background-size: cover;
    background-position: center 10%;
  }
  .fondo-gris-api {
    position: relative;
    left: 1vw;
    top: 0;
    background-color: #e3dfe0 !important;
    width: 48vw;
    margin-top: 10vh;
    max-height: 50vh;
    z-index: 5;
  }
  .fondo-gris-api2 {
    position: relative;
    background-color: #e3dfe0 !important;
    max-height: 90vh;
    max-width: 52vw;
    padding: 7vw;
    margin-top: 15vh;
    padding-bottom: 2vh;
    bottom: 3vh;
  }
  .textocol1 {
    padding-top: 5vh;
    position: relative;
    line-height: 1.5;
  }
  .programa-api {
    position: relative;
    min-height: 5vh;
    padding-left: 2vw;
    color: black;
    white-space: pre;
    font-size: calc(4.5px + 1.48125vw);
  }
  .proyectos {
    position: fixed;
    top: 60vh;
    width: 50vw;
    left: 15vw;
    z-index: 99;
    white-space: nowrap;
    transition-duration: 625ms;
    transition: opacity 0.5s, transform 0.5s;
  }
  li {
    white-space: nowrap;
  }
  .nProyecto {
    position: relative;
    bottom: 4vh;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 60px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    transition: opacity 0.5s, transform 0.5s;
  }
  .nTotalProyectos {
    position: fixed;
    bottom: 10vh;
    left: 18vw;
    font-size: calc(30.5px + 2.8125vw);
    font-family: "Source";
    display: inline-block;
    width: 120px;
    padding-bottom: 0px;
    margin-bottom: 0px;
    color: white;
    transition: opacity 0.5s, transform 0.5s;
    z-index: 99;
    opacity: 0.5;
  }
  .titulo-proyecto-api {
    position: absolute;
    font-family: "Didot-bold";
    color: black !important;
    font-size: calc(20.5px + 2.18125vw);
    top: 20vh;
    left: 25vw;
  }
  .subtitulo-proyecto {
    font-family: "Source";
    font-size: calc(10.5px + 1.78125vw);
  }
  .texto-card {
    font-family: "Source";
    font-size: 20px;
    font-weight: 400;
    padding-top: 20px;
    color: #000000;
    line-height: 1;
  }
  .boton-siguiente {
    position: absolute;
    font-family: "Source";
    top: 30vw;
    left: 20vw;
    z-index: 9999;
  }
  .boton-anterior {
    position: absolute;
    font-family: "Source";
    top: 30vw;
    left: 10vw;
    z-index: 9999;
  }
  .boton-volver-api {
    position: relative;
    font-family: "Source";
    top: 50vw;
    left: 10vw;
    z-index: 9999;
  }
}
</style>
